import * as React from "react"
import { cn } from "@/utils/common.utils"

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "relative overflow-hidden rounded-md bg-gray-100 before:absolute before:inset-0 before:-translate-x-full before:animate-shimmer before:bg-gradient-to-r before:from-transparent before:via-primary/15 before:to-transparent before:content-[''] motion-reduce:before:animate-none",
        className
      )}
      {...props} />
  );
}

export { Skeleton }
